import type { FieldErrors, FieldValues, Path } from "react-hook-form";
import { getFormError } from "../../utils/get-form-error";

export function getFormErrors<T extends FieldValues>(
	errors: FieldErrors<T>,
	fields: Path<T>[],
): string[] {
	return fields
		.map((field) => getFormError(errors, field))
		.filter((message): message is string => message !== null);
}
